/* eslint-disable */
import Full from '@/container/Full'

// dashboard components
const Home = () => import ('@/views/Home')
const Dashboard = () => import('@/views/Dashboard')
const CaseSearch = () => import('@/views/CaseSearch')
const Reports = () => import('@/views/Reports')
const Callback = () => import('@/views/Callback')
const Case = () => import('@/views/Case')
const UserProfile = () => import('@/views/UserProfile')
const LetterTemplates = () => import('@/views/LetterTemplates')
const LetterTemplate = () => import('@/views/LetterTemplate')
const UserAdministration = () => import('@/views/UserAdministration')
const Logout = () => import('@/views/Logout')
const DateRangeTotalsReport = () => import('@/views/Reports/DateRangeTotalsReport')
const YearToDateReport = () => import('@/views/Reports/YearToDateReport')
const NonJurisdictionalReport = () => import('@/views/Reports/NonJurisdictionalReport')
const ImageViewer = () => import('@/views/ImageViewer')

export default {
    path: '/',
    component: Full,
    redirect: '/home',
    children: [
        {
            path: '/home',
            component: Home,
            meta: {
                title: 'message.home',
                breadcrumb: 'Home'
            }
        },
        {
            path: '/dashboard',
            component: Dashboard,
            meta: {
            requiresAuth: true,
            title: 'message.dashboard',
            breadcrumb: 'Dashboard'
            }
        },
        {
            path: '/casesearch',
            component: CaseSearch,
            meta: {
            requiresAuth: true,
            title: 'Case Search',
            breadcrumb: 'Case Search '
            }
        },
        {
            path: '/reports',
            component: Reports,
            meta: {
            requiresAuth: true,
            title: 'Reports',
            breadcrumb: 'Reports '
            }
        },
        {
            path: '/callback',
            component: Callback,
            props: true,
            meta: {
                title: 'Callback',
                breadcrumb: 'Callback '
            }
        },
        {
            path: '/case/:caseId?',
            component: Case,
            meta: {
                requiresAuth: true,
                title: 'Case',
                breadcrumb: 'Case '
            }
        },
        {
            path: '/userprofile',
            component: UserProfile,
            meta: {
                title: 'UserProfile',
                breadcrumb: 'UserProfile'
            }
        },
        {
            path: '/lettertemplates',
            component: LetterTemplates,
            meta: {
                requiresCoroner: true,
                requiresAuth: true,
                title: 'LetterTemplates',
                breadcrumb: 'LetterTemplates'
            }
        },
        {
            path: '/lettertemplate/:letterTemplateId?',
            component: LetterTemplate,
            meta: {
                requiresCoroner: true,
                requiresAuth: true,
                title: 'LetterTemplate',
                breadcrumb: 'LetterTemplate'
            }
        },
        {
            path: '/useradministration',
            component: UserAdministration,
            meta: {
                requiresCountyAdmin: true,
                requiresAuth: true,
                title: 'UserAdministration',
                breadcrumb: 'UserAdministration'
            }
        },
        {
            path: '/logout',
            component: Logout,
            props: true,
            meta: {
                title: 'Logout',
                breadcrumb: 'Logout '
            }
        },
        {
            path: '/daterangetotalsreport',
            component: DateRangeTotalsReport,
            meta: {
                requiresCoroner: true,
                requiresAuth: true,
                title: 'Date Range Totals Report',
                breadcrumb: 'DateRangeTotalsReport'
            }
        },
        {
            path: '/yeartodatereport',
            component: YearToDateReport,
            meta: {
                requiresCoroner: true,
                requiresAuth: true,
                title: 'Year To Date Report',
                breadcrumb: 'YearToDateReport'
            }
        },
        {
            path: '/imageviewer/:parentId?',
            component: ImageViewer,
            props: true,
            meta: {
                requiresCoroner: true,
                requiresAuth: true,
                title: 'Imager Viewer',
                breadcrumb: 'ImageViewer'
            }
        },
        {
            path: '/nonjurisdictionalreport',
            component: NonJurisdictionalReport,
            meta: {
                requiresCoroner: true,
                requiresAuth: true,
                title: 'Non Jurisdictional Report',
                breadcrumb: 'NonJurisdictionalReport'
            }
        },
    ]
}
